module.exports = __webpack_public_path__ + "media/assets/svg/screens/omnichannel_inbox_hexagon_cropped-210324910c6a0d026bfc091dd2b5d0cd.svg";